import React from 'react'
import { Link } from 'react-router-dom'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import UpdateUseOfProceedsModalSF from './UpdateUseOfProceedsModalSF'

const UseOfProceedsDraftUI = ({ context, loan, onRefreshClick,
  onDeleteSubmit, deleteSubmitted, selectedProceedsId,
  onDownloadClick, downloadSubmitted, downloadErrorList,
  updateMode, onUpdateClick, onUpdateCancel,
  deleteMode, onDeleteClick
}) =>
  <div>
    {
      loan.draftProceedsList.length > 0 &&
      <LRTableBodyUI>
        {
          loan.draftProceedsList.map((bill, i) =>
            <LRTableRowUI key={i} className='g_flex_top'
              context={context}
              left={<RowLeftUI context={context} bill={bill}
                onDownloadClick={onDownloadClick}
                downloadSubmitted={downloadSubmitted}
                downloadErrorList={downloadErrorList}
                selectedProceedsId={selectedProceedsId}
              />}
              right={<RowRightUI context={context} bill={bill}
                onDeleteSubmit={onDeleteSubmit}
                deleteSubmitted={deleteSubmitted}
                selectedProceedsId={selectedProceedsId}
                onUpdateClick={onUpdateClick}
                onDeleteClick={onDeleteClick}
              />}
            />
          )
        }
          <LRTableRowUI key="custom" className='g_flex_top'
                        context={context}
                        left={<label style={{ padding: '10px', fontWeight: 'bold' }}>Total : </label>}
                        right={<span>{loan.draftBillsSumF4}</span>}
          />
      </LRTableBodyUI>
    }

    <UpdateUseOfProceedsModalSF
      context={context} loan={loan} selectedProceedsId={selectedProceedsId}
      updateMode={updateMode} onCancelClick={onUpdateCancel}
      onRefreshClick={onRefreshClick}
    />
  </div>

const RowLeftUI = ({ bill, onDownloadClick, downloadSubmitted, downloadErrorList, selectedProceedsId }) =>
  <div>
    {bill.itemDetails}<br />
    {bill.vendorName}<br />
    {
      bill.hasAttachment &&
      <div className='g_flex_h g_m_top_50 g_flex_left g_flex_top'>
        <Link className='g_m_right_25' onClick={onDownloadClick} to='#' data-id={bill.draftProceedsId}>
          Download attachment
        </Link>
        <SpinnerUI show={downloadSubmitted && selectedProceedsId == bill.draftProceedsId} />
        <span className='g_m_left_50'>
          {
            downloadErrorList && downloadErrorList.length && downloadErrorList[0].message &&
              selectedProceedsId == bill.draftProceedsId ?
              downloadErrorList[0].message : ''
          }
        </span>
      </div>
    }
    {
      !bill.hasAttachment &&
      <span>No attachment</span>
    }
      <br/>
      {bill.supplierDocumentReference && <span>{bill.supplierDocumentReference}</span>}
  </div>

const RowRightUI = ({ context, bill, onDeleteSubmit, deleteSubmitted, selectedProceedsId, onUpdateClick, onDeleteClick }) =>
  <div className='g_flex_h g_flex_top g_flex_right'>
    {bill.amountF2}
    <span className='icon icon-pencil g_m_left_50' onClick={onUpdateClick} data-row-id={bill.draftProceedsId} />
    <span className='icon icon-trash-o g_m_left_50' onClick={onDeleteClick} data-row-id={bill.draftProceedsId} />
    {
      bill.status === 'open' && context.permissions.includes('su_manage') &&
      <span className='g_flex_h g_m_top_25'>
        <SpinnerUI show={deleteSubmitted && selectedProceedsId == bill.billId} reserveSpace={true} />
        <ButtonTinyUI label='Delete' rowId={bill.billId} onClick={onDeleteSubmit} />
      </span>
    }
  </div>

export default UseOfProceedsDraftUI
